import { useEffect, useRef } from 'react'
import type { MutableRefObject, VFC } from 'react'

type ParentRefProps = {
  parentRef: MutableRefObject<HTMLElement | null>
  closest?: string
}
const ParentRef: VFC<ParentRefProps> = (({ parentRef, closest }) => {
  const divRef = useRef<HTMLDivElement>(null)
  const parentExist = Boolean(parentRef.current && document.body.contains(parentRef.current))

  useEffect(() => {
    if (divRef.current) {
      parentRef.current = closest ? divRef.current.closest(closest) : divRef.current.parentNode as HTMLElement
    }
    return () => { // unmount
      if (parentRef.current && !document.body.contains(parentRef.current)) {
        parentRef.current = null
      }
    }
  }, [parentRef, closest, parentExist])

  if (parentExist) {
    return null
  }

  return <div ref={divRef} style={{ display: 'hidden' }}></div>
})

export default ParentRef
